import { render } from "./addTemplateMtlNo.vue?vue&type=template&id=99194b72"
import script from "./addTemplateMtlNo.vue?vue&type=script&lang=js"
export * from "./addTemplateMtlNo.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./addTemplateMtlNo.vue?vue&type=style&index=1&id=99194b72&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__